import { render, staticRenderFns } from "./trimHandleTopRight.vue?vue&type=template&id=323f3c5c&"
import script from "./trimHandleTopRight.vue?vue&type=script&lang=ts&"
export * from "./trimHandleTopRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports